module.exports = __webpack_public_path__ + "img/nlic_detail.198def9d.jpg";